import { aDeleteRule, mockDeleteRuleOperationMutation } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const deleteRuleResponse = {
  __typename: 'Mutation' as const,
  deleteRule: aDeleteRule({ ok: true }),
};

export const handlers = [
  mockDeleteRuleOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: deleteRuleResponse,
      });
    }
  ),
];
